import {type ActionD, type YTError} from '../../../../types';
import {
    type NAVIGATION_ATTRIBUTES_EDITOR_ERROR,
    type NAVIGATION_ATTRIBUTES_EDITOR_PARTIAL,
    type NAVIGATION_ATTRIBUTES_EDITOR_REQUEST,
    type NAVIGATION_ATTRIBUTES_EDITOR_SUCCESS,
} from '../../../../constants/navigation/modals/attributes-editor';
import {type Action} from 'redux';

export interface NavAttrEditorState {
    loading: boolean;
    loaded: boolean;
    error: YTError | undefined;

    paths?: Array<string>;
    visible: boolean;

    attributesMap: {[path: string]: object};
}

const initialState: NavAttrEditorState = {
    loading: false,
    loaded: false,
    error: undefined,
    attributesMap: {},

    paths: undefined,
    visible: false,
};

export default function editAttributesReducer(
    state: NavAttrEditorState = initialState,
    action: NavAttrEditorAction,
): NavAttrEditorState {
    switch (action.type) {
        case 'NAVIGATION_ATTRIBUTES_EDITOR_REQUEST':
            return {...state, loading: true};
        case 'NAVIGATION_ATTRIBUTES_EDITOR_SUCCESS':
            return {
                ...state,
                loading: false,
                loaded: true,
                error: undefined,
                ...action.data,
            };
        case 'NAVIGATION_ATTRIBUTES_EDITOR_ERROR':
            return {
                ...state,
                loading: true,
                loaded: false,
                error: action.data,
            };
        case 'NAVIGATION_ATTRIBUTES_EDITOR_PARTIAL':
            return {...state, ...action.data};
    }
    return state;
}

export type NavAttrEditorAction =
    | Action<typeof NAVIGATION_ATTRIBUTES_EDITOR_REQUEST>
    | ActionD<
          typeof NAVIGATION_ATTRIBUTES_EDITOR_SUCCESS,
          Pick<NavAttrEditorState, 'attributesMap' | 'paths'>
      >
    | ActionD<typeof NAVIGATION_ATTRIBUTES_EDITOR_ERROR, NavAttrEditorState['error']>
    | ActionD<
          typeof NAVIGATION_ATTRIBUTES_EDITOR_PARTIAL,
          Omit<NavAttrEditorState, 'loading' | 'loaded' | 'error' | 'attributesMap'>
      >;
